import React from "react";
import { connect } from "react-redux";
import {
  postClientManagementDetails,
  getClientManagementList,
  postClientUserDetails,
} from "../Actions/ClientManagementAPI";
import { confirmAlert } from "react-confirm-alert";
import "react-datepicker/dist/react-datepicker.css";
import AddIcon from "../UIComponents/AddIcon";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import { toast } from "react-toastify";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/style.css";

let user = JSON.parse(localStorage.getItem("currentUser"));
class ClientManagementAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ClientInfo: {
        name: "",
        mail: "",
        phone: "",
        address: "",
        logoName: "",
        logo: "",
        createdBy: user.email,
      },
      PhotoFile: "",
      owner: false,
      management: false,
      fleetmanager: [],
      superintendent: [],
      executive: [],
      isEmailNotificationEnabled: false,
      level2ToEmails: [],
      level2CcEmails: [],
      monthlyToEmails: [],
      monthlyCcEmails: [],

    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
  }
  componentDidMount() {
    this.props.dispatch({ type: "SubBannerTitle", data: "Client Management" });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { fleetManagerList, techSuperintendentList, techExecutiveList } =
      nextProps;
    if (fleetManagerList) {
      prevState.fleetmanager = fleetManagerList;
    }
    if (techSuperintendentList) {
      prevState.superintendent = techSuperintendentList;
    }
    if (techExecutiveList) {
      prevState.executive = techExecutiveList;
    }
  }

  // SubmitData() {
  //   this.props.dispatch(postClientManagementDetails(this.state.ClientInfo));
  //   this.props.history.push("/Home/Management/Client");
  // }

  SubmitData() {
    const {
      dispatch,
      fleetManagerlist,
      TechExecutivelist,
      TechSuperintendentlist,
    } = this.props;
    let searchData = {
      Name: "",
      PageNumber: 1,
      PageSize: 25,
    };
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.state.ClientInfo.mail !== "") {
      if (emailregex.test(this.state.ClientInfo.mail)) {
        let url2 = `${API.userExist}?Mail=${this.state.ClientInfo.mail}`;
        if (this.state.PhotoFile !== "") {
          axios
            .get(url2, {
              headers: {
                key: user.accessToken,
              },
            })
            .then((response) => {
              if (response.data === true) {
                let url = `${API.PostShippingCompany}`;
                let data = {
                  companyName: this.state.ClientInfo.name,
                  mail: this.state.ClientInfo.mail,
                  telephone: this.state.ClientInfo.phone,
                  address: this.state.ClientInfo.address,
                  createdBy: this.state.ClientInfo.createdBy,
                  logo: this.state.ClientInfo.logo,
                  mailAlertForLevel2AndMonthlyReport:
                    this.state.isEmailNotificationEnabled,
                  level2ToMailForAlert: this.state.level2ToEmails.toString(),
                  level2CcMailForAlert: this.state.level2CcEmails.toString(),
                  monthlyReportToMailForAlert: this.state.monthlyToEmails.toString(),
                  monthlyReportCcMailForAlert: this.state.monthlyCcEmails.toString(),
                };
                axios
                  .post(url, data, {
                    headers: {
                      key: user.accessToken,
                    },
                  })
                  .then((response) => {
                    if (response.data) {
                      axios.interceptors.response.use(
                        function (response) {
                          dispatch(showLoader());
                          return response;
                        },
                        function (error) {
                          dispatch(hideLoader());
                          return Promise.reject(error);
                        }
                      );
                    }
                    let user1 = fleetManagerlist.map((u1) => {
                      let fleet = {};
                      fleet.clientId = response.data;
                      fleet.userName = u1.userName;
                      fleet.userRole = u1.userRole;
                      fleet.email = u1.email;
                      fleet.telephone = u1.telephone;
                      fleet.createdBy = u1.createdBy;
                      return fleet;
                    });

                    let user2 = TechSuperintendentlist.map((u2) => {
                      let superintendent = {};
                      superintendent.clientId = response.data;
                      superintendent.userName = u2.userName;
                      superintendent.userRole = u2.userRole;
                      superintendent.email = u2.email;
                      superintendent.telephone = u2.telephone;
                      superintendent.createdBy = u2.createdBy;
                      return superintendent;
                    });

                    let user3 = TechExecutivelist.map((u3) => {
                      let executive = {};
                      executive.clientId = response.data;
                      executive.userName = u3.userName;
                      executive.userRole = u3.userRole;
                      executive.email = u3.email;
                      executive.telephone = u3.telephone;
                      executive.createdBy = u3.createdBy;
                      return executive;
                    });

                    let clientUsers = [...user1, ...user2, ...user3];
                    let url = `${API.postClient}`;
                    axios
                      .post(url, clientUsers, {
                        headers: {
                          key: user.accessToken,
                        },
                      })
                      .then((response) => {
                        if (response.status === 500) {
                          swal(
                            "Error!",
                            "Error when adding the data. Try again.",
                            "warning"
                          );
                        } else {
                          if (response.data === true) {
                            toast.success("Added Successfully", {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: true,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                            });
                            axios.interceptors.response.use(
                              function (response) {
                                dispatch(hideLoader());
                                return response;
                              },
                              function (error) {
                                dispatch(hideLoader());
                                return Promise.reject(error);
                              }
                            );
                          }
                          dispatch({
                            type: "postClientUserDetailSuccess",
                            data: response.data,
                          });
                          this.moveClientList();
                        }
                      })
                      .catch((error) => {
                        swal(
                          "Error!",
                          "Something went wrong. Please try again.",
                          "warning"
                        );
                        dispatch({
                          type: "postClientUserDetailFailure",
                          error: "ERROR",
                        });
                      });
                    dispatch(getClientManagementList(searchData));
                    dispatch({
                      type: "postClientDetailsSuccess",
                      data: response.data,
                    });
                  })
                  .catch((error) => {
                    swal("Error!", "Something went wrong. Please try again.", "warning");
                    dispatch({
                      type: "postClientDetailsFailure",
                      error: "ERROR",
                    });
                  });
              } else if (response.data === false) {
                swal(
                  "Error!",
                  "User already exists.",
                  "warning"
                );
                this.state.ClientInfo.email = "";
                this.setState({});
              }
              dispatch({
                type: "getUserExistListSuccess",
                data: response.data,
              });
            })
            .catch((error) => {
              dispatch({
                type: "getUserExistListFailure",
                data: "error",
              });
            });

        } else {
          swal("Error!", "Logo is mandatory", "warning");
        }
      }
      else {
        swal("Error!", "Invalid email format", "warning");
      }
    }
    else {
      swal("Error!", "Email is mandatory", "warning");
    }
  }
  ClearInput = () => {
    this.state.ClientInfo.logoName = "";
    this.state.ClientInfo.logo = "";
    this.state.PhotoFile = "";
    this.setState({});
  };

  handleInputChange(e) {
    let nodeName = e.target.name;
    const regex = /^\d*$/;
    if (nodeName == 'phone') {
      if (regex.test(e.target.value)) {
        this.state.ClientInfo[nodeName] = e.target.value;
      }
    }
    else {
      this.state.ClientInfo[nodeName] = e.target.value;
    }

    this.setState({});
  }

  handleEmailNotificationToggle = (e) => {
    this.setState({
      isEmailNotificationEnabled: e.target.checked,
    });
  };

  OpenPopup() {
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {

            this.state.ClientInfo.logoName = "";
            this.state.ClientInfo.logo = "";
            this.state.PhotoFile = "";
            this.setState({});
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  }

  handleInputFileChange(event) {
    let _this = this;
    let file = event?.target?.files[0];
    let filename = event?.target?.files[0].name;
    let size = event?.target?.files[0].size;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let FileUrl = reader?.result;
      let finalResult = reader?.result.split(",");
      _this.state.PhotoFile = reader?.result;
      _this.state.ClientInfo["logo"] = finalResult[1];
      _this.state.ClientInfo["logoName"] = filename;
      _this.setState({});
    };
  }

  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const {
      showSidePane,
      fleetManagerlist,
      TechSuperintendentlist,
      TechExecutivelist,
    } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div className="row ">
                  <div className="col-lg-12">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-1 mt-2 pl-3"
                          style={{ color: "092a51" }}
                        >
                          Basic Information
                        </h5>
                      </div>
                    </div>
                    <div className="row search-filter-box pb-4">
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Name</label>
                        <input
                          className="form-control"
                          type="text"
                          name="name"
                          placeholder="Name"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.ClientInfo.name}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Email<span className="mandatory">*</span></label>
                        <input
                          className="form-control"
                          type="text"
                          name="mail"
                          placeholder="Email"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.ClientInfo.mail}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Phone </label>
                        <input
                          className="form-control"
                          type="text"
                          name="phone"
                          placeholder="Phone"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.ClientInfo.phone}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Address</label>
                        <textarea
                          className="form-control"
                          style={{ minHeight: 40, maxHeight: 200 }}
                          name="address"
                          placeholder="Address"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.ClientInfo.address}
                        />
                        {/* <input
                        className="form-control"
                        type="textarea"
                        name="address"
                        placeholder="Address"
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.ClientInfo.address}
                      ></input> */}
                      </div>
                      <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                        <label className="form-label">Logo<span className="mandatory">*</span></label>
                        <br></br>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              Browse File
                              <input
                                type="file"
                                id="files"
                                title=" "
                                accept=".png,.jpg"
                                style={{ marginRight: 40 }}
                                onChange={(e) => this.handleInputFileChange(e)}
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            placeholder=""
                            name="username"
                            value={this.state.ClientInfo.logoName}
                          />
                          {this.state.ClientInfo.logoName ? (
                            <div
                              class="input-group-append "
                              style={{ cursor: "pointer" }}
                            >
                              <div className="input-group-text">
                                <span
                                  class="fa fa-times"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput()}
                                ></span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-12 col-sm-12  col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center"
                            : "col-12 col-sm-12  col-md-4 col-lg-4 col-xl-4 pt-2 align-items-center"
                        }
                      >
                        {this.state.PhotoFile &&
                          this.state.PhotoFile !== "" ?
                          <>
                            <div className="row align-items-center">
                              <div
                                className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center"
                                style={{ display: "flex", marginTop: "35px" }}
                              >
                                <div className="ml-2">
                                  <img
                                    src={this.state.PhotoFile}
                                    className="cursorPointer"
                                    style={{
                                      width: "55px",
                                      height: "42px",
                                      marginTop: "-9px",
                                    }}
                                  />
                                </div>
                                <div
                                  className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4"
                                  style={{ fontSize: "10px", marginTop: "-15px" }}
                                >
                                  <div className="px-2 overflow cursorPointer"
                                  >
                                    {this.state.ClientInfo.logoName}

                                  </div>
                                </div>
                                <div
                                  className=""
                                  style={{ marginTop: "-16px" }}
                                >
                                  <i
                                    className="fa fa-trash click m-1"
                                    onClick={() => {
                                      this.OpenPopup();
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </>
                          : ""}
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-lg-12">
                        <div
                          className=" card MM-card-header mb-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <div
                            className="card-body flex"
                            style={{
                              padding: "0rem",
                              backgroundColor: "#1a3464",
                              color: "white",
                            }}
                          >
                            <h5
                              className="card-title mt-2 ml-1 pl-3"
                              style={{ color: "092a51" }}
                            >
                              Marine Managers
                            </h5>
                            <div
                              className="m-1 flex"
                              onClick={() => this.showFleetManagersSidePane()}
                            >
                              <AddIcon />
                            </div>
                          </div>
                        </div>
                        <div className="search-filter-box pt-4">
                          {fleetManagerlist
                            ? this.renderFleetManagerCard()
                            : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div
                          className=" card MM-card-header mb-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <div
                            className="card-body flex"
                            style={{
                              padding: "0rem",
                              backgroundColor: "#1a3464",
                              color: "white",
                            }}
                          >
                            <h5
                              className="card-title mt-2 ml-2 pl-3"
                              style={{ color: "092a51" }}
                            >
                              Marine Superintendents
                            </h5>
                            <div
                              className="m-1 flex"
                              onClick={() =>
                                this.showTechSuperintendentsSidePane()
                              }
                            >
                              <AddIcon />
                            </div>
                          </div>
                        </div>
                        <div className="search-filter-box pt-4">
                          {TechSuperintendentlist
                            ? this.renderTechSuperintendentCard()
                            : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div
                          className=" card MM-card-header mb-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <div
                            className="flex card-body"
                            style={{
                              padding: "0rem",
                              backgroundColor: "#1a3464",
                              color: "white",
                            }}
                          >
                            <h5
                              className="card-title mt-2 ml-2 pl-3"
                              style={{ color: "092a51" }}
                            >
                              DPA
                            </h5>
                            <div
                              className="m-1 flex"
                              onClick={() => this.showTechExecutiveSidePane()}
                            >
                              <AddIcon />
                            </div>
                          </div>
                        </div>
                        <div className="search-filter-box pt-4">
                          {TechExecutivelist
                            ? this.renderTechExecutiveCard()
                            : null}
                        </div>
                      </div>

                    </div>
                    <div className="row pb-0">
                      <div className="col-lg-12">
                        <div
                          className=" card MM-card-header mb-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <div
                            className="flex card-body"
                            style={{
                              padding: "0rem",
                              backgroundColor: "#1a3464",
                              color: "white",
                            }}
                          >
                            <h5
                              className="card-title mt-2 ml-2 pl-3"
                              style={{ color: "092a51" }}
                            >
                              Email Notification
                            </h5>
                          </div>
                        </div>
                        <div className="search-filter-box mt-2 pb-3">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="d-flex align-items-center">
                                <input
                                  style={{ height: "20px", width: "20px" }}
                                  type="checkbox"
                                  name="notificationToggle"
                                  id="notificationToggle"
                                  className="mr-2"
                                  checked={this.state.isEmailNotificationEnabled}
                                  onChange={this.handleEmailNotificationToggle}
                                ></input>
                                <label
                                  htmlFor="notificationToggle"
                                  className="form-label"
                                >
                                  Sent level 2 and monthly report notification
                                </label>
                              </div>
                            </div>
                          </div>
                          {this.state.isEmailNotificationEnabled ? (
                            <>
                              <div className="row pt-3">
                                <div className="col-lg-12">
                                  <label className="form-label mb-0">
                                    Level 2 escalation email
                                  </label>
                                </div>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-5">
                                  <label className="form-label">To Email</label>
                                  <ReactMultiEmail
                                    className="level2ToEmails"
                                    emails={this.state.level2ToEmails}
                                    onChange={(_emails) => {
                                      this.setState({ level2ToEmails: _emails });
                                    }}
                                    getLabel={(email, index, removeEmail) => {
                                      return (
                                        <label
                                          className="m-1"
                                          key={index}
                                          style={{
                                            backgroundColor: "lightgray",
                                            fontSize: "14px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {email}
                                          <span
                                            style={{
                                              fontSize: "20px",
                                              verticalAlign: "middle",
                                              marginLeft: ".25rem",
                                            }}
                                            data-tag-handle
                                            name="delete"
                                            onClick={() => removeEmail(index)}
                                          >
                                            &times;
                                          </span>
                                        </label>
                                      );
                                    }}
                                  />
                                </div>
                                <div className="col-lg-5">
                                  <label className="form-label">Cc Email</label>
                                  <ReactMultiEmail
                                    className="level2CcEmails"
                                    emails={this.state.level2CcEmails}
                                    onChange={(_emails) => {
                                      this.setState({ level2CcEmails: _emails });
                                    }}
                                    getLabel={(email, index, removeEmail) => {
                                      return (
                                        <label
                                          className="m-1"
                                          key={index}
                                          style={{
                                            backgroundColor: "lightgray",
                                            fontSize: "14px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {email}
                                          <span
                                            style={{
                                              fontSize: "20px",
                                              verticalAlign: "middle",
                                              marginLeft: ".25rem",
                                            }}
                                            data-tag-handle
                                            name="delete"
                                            onClick={() => removeEmail(index)}
                                          >
                                            &times;
                                          </span>
                                        </label>
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="row pt-3">
                                <div className="col-lg-12">
                                  <label className="form-label mb-0">
                                    Monthly report email
                                  </label>
                                </div>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-5">
                                  <label className="form-label">To Email</label>
                                  <ReactMultiEmail
                                    className="monthlyToEmails"
                                    emails={this.state.monthlyToEmails}
                                    onChange={(_emails) => {
                                      this.setState({ monthlyToEmails: _emails });
                                    }}
                                    getLabel={(email, index, removeEmail) => {
                                      return (
                                        <label
                                          className="m-1"
                                          key={index}
                                          style={{
                                            backgroundColor: "lightgray",
                                            fontSize: "14px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {email}
                                          <span
                                            style={{
                                              fontSize: "20px",
                                              verticalAlign: "middle",
                                              marginLeft: ".25rem",
                                            }}
                                            data-tag-handle
                                            name="delete"
                                            onClick={() => removeEmail(index)}
                                          >
                                            &times;
                                          </span>
                                        </label>
                                      );
                                    }}
                                  />
                                </div>
                                <div className="col-lg-5">
                                  <label className="form-label">Cc Email</label>
                                  <ReactMultiEmail
                                    className="monthlyCcEmails"
                                    emails={this.state.monthlyCcEmails}
                                    onChange={(_emails) => {
                                      this.setState({ monthlyCcEmails: _emails });
                                    }}
                                    getLabel={(email, index, removeEmail) => {
                                      return (
                                        <label
                                          className="m-1"
                                          key={index}
                                          style={{
                                            backgroundColor: "lightgray",
                                            fontSize: "14px",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {email}
                                          <span
                                            style={{
                                              fontSize: "20px",
                                              verticalAlign: "middle",
                                              marginLeft: ".25rem",
                                            }}
                                            data-tag-handle
                                            name="delete"
                                            onClick={() => removeEmail(index)}
                                          >
                                            &times;
                                          </span>
                                        </label>
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row search-filter-box pt-1">
                      <div className="col-lg-12 py-2">
                        <div
                          className="mb-1 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SubmitData()}
                          >
                            Submit
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.moveClientList()}
                          >
                            {" "}
                            Cancel{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderFleetManagerCard = () => {
    const { showSidePane, fleetManagerlist } = this.props;
    return (
      <>
        {fleetManagerlist &&
          fleetManagerlist.map((item) => (
            <div
              className="card click"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                      <div className="row">
                        <div
                          className={
                            showSidePane ? "col-sm-6 mb-1" : "col-sm-4"
                          }
                        >
                          <span>
                            <strong>Name : </strong>
                            {item.userName}{" "}
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane ? "col-sm-6 mb-1" : "col-sm-4"
                          }
                        >
                          <span>
                            <strong>Email : </strong>
                            {item.email}
                          </span>
                        </div>
                        <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                          <span>
                            <strong>Phone : </strong>
                            {item.telephone}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2 col-md-1 col-2 col-m-auto">
                      <div
                        className={showSidePane ? "text-center" : "text-center"}
                      >
                        <i
                          className="fa fa-edit fa-2x"
                          style={{ marginLeft: "-15px" }}
                          onClick={() =>
                            this.EditEquipment("FleetManager", item)
                          }
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  };
  renderTechSuperintendentCard = () => {
    const { showSidePane, TechSuperintendentlist } = this.props;

    return (
      <>
        {TechSuperintendentlist &&
          TechSuperintendentlist.map((item) => (
            <div
              className="card click"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                      <div className="row">
                        <div
                          className={
                            showSidePane ? "col-sm-6 mb-1" : "col-sm-4"
                          }
                        >
                          <span>
                            <strong>Name : </strong>
                            {item.userName}
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane ? "col-sm-6 mb-1" : "col-sm-4"
                          }
                        >
                          <span>
                            <strong>Email : </strong>
                            {item.email}
                          </span>
                        </div>
                        <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                          <span>
                            <strong>Phone : </strong>
                            {item.telephone}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2 col-md-1 col-2 col-m-auto">
                      <div
                        className={showSidePane ? "text-center" : "text-center"}
                      >
                        <i
                          className="fa fa-edit fa-2x"
                          style={{ marginLeft: "-15px" }}
                          onClick={() =>
                            this.EditEquipment("TechSuperintendent", item)
                          }
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  };
  renderTechExecutiveCard = () => {
    const { showSidePane, TechExecutivelist } = this.props;
    return (
      <>
        {TechExecutivelist &&
          TechExecutivelist.map((item) => (
            <div
              className="card click"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                      <div className="row">
                        <div
                          className={
                            showSidePane ? "col-sm-6 mb-1" : "col-sm-4"
                          }
                        >
                          <span>
                            <strong>Company Name : </strong>
                            {item.userName}
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane ? "col-sm-6 mb-1" : "col-sm-4"
                          }
                        >
                          <span>
                            <strong>Email : </strong>
                            {item.email}
                          </span>
                        </div>
                        <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                          <span>
                            <strong>Phone : </strong>
                            {item.telephone}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2 col-md-1 col-2 col-m-auto">
                      <div
                        className={showSidePane ? "text-center" : "text-center"}
                      >
                        <i
                          className="fa fa-edit fa-2x"
                          style={{ marginLeft: "-15px" }}
                          onClick={() =>
                            this.EditEquipment("TechExecutive", item)
                          }
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  };

  EditEquipment(type, item) {
    this.props.dispatch({ type: "EditUser", data: true });
    if (type === "FleetManager") {
      this.props.dispatch({ type: "GetFleetManagerDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push("/Home/Management/ClientAdd/FleetManager");
    } else if (type === "TechSuperintendent") {
      this.props.dispatch({ type: "GetTechSuperintendentDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push("/Home/Management/ClientAdd/TechSuperintendent");
    } else if (type === "TechExecutive") {
      this.props.dispatch({ type: "GetTechExecutiveDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push("/Home/Management/ClientAdd/TechExecutive");
    }
  }

  moveClientList = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Client");
    // this.props.history.goBack();
  };
  showFleetManagersSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetFleetManagerDetails", data: null });
    this.props.history.push("/Home/Management/ClientAdd/FleetManager");
  }

  showTechSuperintendentsSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetTechSuperintendentDetails", data: null });
    this.props.history.push("/Home/Management/ClientAdd/TechSuperintendent");
  }

  showTechExecutiveSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetTechExecutiveDetails", data: null });
    this.props.history.push("/Home/Management/ClientAdd/TechExecutive");
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    fleetManagerlist: state.MasterScreenReducer.fleetManagerlist || [],
    TechSuperintendentlist:
      state.MasterScreenReducer.TechSuperintendentlist || [],
    TechExecutivelist: state.MasterScreenReducer.TechExecutivelist || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientManagementAdd);
